import React from 'react';
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
// import { octagonStarPropType } from '../type';
const TITLE = 'Octagon Star';
const ID = '__star__';
class OctagonStar extends React.Component {

  render() {
    const {title, fill, width, height, viewBox, ...other} = this.props;
    const h = vw.HEIGHT
    other.fill = fill
    other.width = width || h
    other.height = width || h
    other.viewBox = viewBox || `0 0 ${h} ${h}`
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        aria-labelledby='title'
        {...other}>
        <title>{title || TITLE}</title>
        { /* path is copied from /home/ps/web/pub/img/sprite.icon.svg, fill-rule => fillRule  */ }
        <path id={ID} pathLength='1' d='M 7,7 41,7 41,41 7,41 M 0,24 24,0 48,24 24,48' fillRule='evenodd'/>
      </svg>
    );
  }
}
// OctagonStar.propTypes = octagonStarPropType;
// <title id="title">{title || TITLE}</title>
export default OctagonStar;
